module.exports = __webpack_public_path__ + "img/icb-leo-novice-e@3x.a47db3b7.png";